import React, { useEffect, useState } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import PastoralService from "Lib/API/PastoralApi";
import AlertDialog from "components/Dialog/index";
import MenuTabs from "components/MenuTabs/MenuTabs";
import MainTabs from "components/mainTabs/MainTabs";
import { useDisableEnterKey } from "hook";
import { useUrlTab } from "hook/useUrlTab";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import MyModal from "../../components/MyModal";
import NotAuthorized from "../../components/NotAuthorized";
import RightDrawer from "../../components/drawer/index.js";
import MembersDrawer from "../Members/MembersDrawer/index";
import Dashboard from "./Dashboard";
import EasyCareHeader from "./EasyCareHeader";
import MemberEventDrawer from "./MemberEventDrawer/MemberEventDrawer";
import ScheduleReports from "./ScheduleReports";
import EventsDrawer from "./eventsDrawer/EventDrawer";
import NewEvent from "./newEvent/newEvent.js";
import NewTask from "./newTask/newTask";
import "./styles.scss";
import TaskAutomation from "./taskAutomation";
import SideDrawer from "../Members/MemberDetails/EasyCare/view/profile/index";
import EventDrawer from "../Members/MemberDetails/EasyCare/view/event-listing/index";

const tabs = [
  {
    title: "Dashboard",
    value: "dashboard",
    width: "12rem",
  },
  {
    title: "Task Automation",
    value: "task-automation",
    width: "12rem",
  },
  {
    title: "Update Reports",
    value: "schedule-reports",
    width: "12rem",
  },
];

const Events = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { search, pathname } = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(search);
  const eventIdParam = searchParams.get("eventId");

  const [activeTab, setActiveTab] = useState("dashboard");
  // ?tab=dashboard|task-automation|schedule-reports opens that tab (e.g. from the global search)
  useUrlTab(setActiveTab, tabs.map((tab) => tab.value));

  const [openEventDrawer, setOpenEventDrawer] = useState(false);
  const [newEventDrawer, setNewEventDrawer] = useState(false);
  const [newTaskDrawer, setNewTaskDrawer] = useState(false);
  const [isEventsActive, setIsEventsActive] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [openMemberEventDrawer, setOpenMemberEventDrawer] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [callTasksAgain, setCallTasksAgain] = useState(false);
  const [callFeedsAgain, setCallFeedsAgain] = useState(false);
  const [callEventsTypeAgain, setCallEventsTypeAgain] = useState(false);
  const [callEventsAgain, setCallEventsAgain] = useState(false);
  const [openContactDrawer, setOpenContactDrawer] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [eventTypes, setEventType] = useState([]);
  const [formattedEventTypes, setFormattedEventTypes] = useState([]);
  const [getEventTypesLoading, setGetEventTypesLoading] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [deleteEventLoading, setDeleteEventLoading] = useState(false);
  const [successFullTask, setSuccessFullTask] = useState(false);

  const handelEventDrawer = (item) => {
    setOpenEventDrawer(true);
    setSelectedEvent(item);
  };

  const resetSearchParams = () => {
    history.push({
      pathname,
      search: "",
    });
  };

  const mainUrl = window.location.href.split("/");

  let orgInfo = localStorage?.getItem("authorizedModules")
    ? JSON.parse(localStorage?.getItem("authorizedModules"))
    : [];

  const fetchEventsTypes = async (page) => {
    setGetEventTypesLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.getEventTypes({ token, page })
      .then((res) => {
        if (res) {
          const formattedEvents = res?.eventTypes.map((item) => ({
            label: item?.name,
            value: item?.id,
          }));
          setEventType(res?.eventTypes);
          setFormattedEventTypes(formattedEvents);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setGetEventTypesLoading(false);
      });
  };

  useEffect(() => {
    if (!isEventsActive) return;
    fetchEventsTypes(1);
  }, [isEventsActive]);

  useEffect(() => {
    let check =
      orgInfo !== undefined ??
      orgInfo?.map((item) => {
        if (item?.moduleName == "events") {
          return setIsEventsActive(item?.active);
        }
      });
    setIsEventsActive(
      orgInfo?.find((item) => item?.moduleName === "pastoral")?.active
    );
  }, []);

  const onTabsChange = (tab) => {
    setActiveTab(tab?.value);
  };

  const openNewTaskDrawer = () => {
    setNewTaskDrawer(true);
  };

  const openMemberEventDrawerHandler = (data) => {
    setOpenMemberEventDrawer(true);
    setSelectedProfile(data);
  };

  const closeMemberEventDrawerHandler = () => {
    setOpenMemberEventDrawer(false);
    setSelectedProfile(null);
    resetSearchParams();
  };

  const openContactDrawerHandler = (item) => {
    setOpenContactDrawer(true);
    setSelectedContact(item);
  };

  const closeContactDrawerHandler = () => {
    setOpenContactDrawer(false);
    setSelectedContact(null);
  };

  useDisableEnterKey(true);

  const closeTaskDrawer = () => {
    setNewTaskDrawer(false);
    setSuccessFullTask(false);
  };

  const closeEventDrawer = () => {
    setNewEventDrawer(false);
  };

  const closeModal = () => {
    setConfirmClose(true);
  };
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setNewTaskDrawer(false);
    setNewEventDrawer(false);
    setSuccessFullTask(false);
  };

  useEffect(() => {
    if (!eventIdParam) return;
    openMemberEventDrawerHandler({ eventId: eventIdParam });
  }, [eventIdParam]);

  const displayContent = () => {
    switch (activeTab) {
      case "dashboard":
        return (
          <Dashboard
            handelEventDrawer={handelEventDrawer}
            openNewTaskDrawer={openNewTaskDrawer}
            openMemberEventDrawer={openMemberEventDrawerHandler}
            setCallTasksAgain={setCallTasksAgain}
            callTasksAgain={callTasksAgain}
            setCallFeedsAgain={setCallFeedsAgain}
            callFeedsAgain={callFeedsAgain}
            selectedEvent={selectedEvent}
            callEventsAgain={callEventsAgain}
            openContactDrawerHandler={openContactDrawerHandler}
            eventTypes={eventTypes}
            eventTypesLoading={getEventTypesLoading}
          />
        );
      case "task-automation":
        return (
          <div className="easycare__tabs-content mt-10">
            <TaskAutomation
              eventTypes={formattedEventTypes}
              eventTypesLoading={getEventTypesLoading}
            />
          </div>
        );
      case "schedule-reports":
        return (
          <div className="easycare__tabs-content mt-10">
            <ScheduleReports
              eventTypes={formattedEventTypes}
              eventTypesLoading={getEventTypesLoading}
            />
          </div>
        );
      default:
        return (
          <Dashboard
            handelEventDrawer={handelEventDrawer}
            openMemberEventDrawer={openMemberEventDrawerHandler}
            openNewTaskDrawer={openNewTaskDrawer}
            setCallTasksAgain={setCallTasksAgain}
            callTasksAgain={callTasksAgain}
            setCallFeedsAgain={setCallFeedsAgain}
            callFeedsAgain={callFeedsAgain}
            selectedEvent={selectedEvent}
            callEventsAgain={callEventsAgain}
            openContactDrawerHandler={openContactDrawerHandler}
            evenTypes={eventTypes}
            eventTypesLoading={getEventTypesLoading}
          />
        );
    }
  };

  const openConfirmationHandler = () => {
    setOpenConfirmation(true);
  };

  const closeConfirmationHandler = () => {
    setOpenConfirmation(false);
  };

  const deleteEventHandler = async () => {
    if (deleteEventLoading) return;
    setDeleteEventLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.deleteEvent({ token, eventId: selectedProfile?.eventId })
      .then((res) => {
        if (res) {
          toastr.success("Success", "Event Deleted Successfully!");
          closeConfirmationHandler();
          closeMemberEventDrawerHandler();
          setCallEventsTypeAgain((prevState) => !prevState);
          setCallEventsAgain((prevState) => !prevState);
          setCallTasksAgain((prevState) => !prevState);
          setCallFeedsAgain((prevState) => !prevState);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDeleteEventLoading(false);
      });
  };

  const handleEvent = async (data) => {
    setSelectedProfile(data);
    setOpenMemberEventDrawer(true);
  };

  return !isEventsActive ? (
    <NotAuthorized title={"Easycare"} />
  ) : (
    <>
      <div className="events pr-10 pt-10 w-100">
        <EasyCareHeader
          setNewTaskDrawer={setNewTaskDrawer}
          setNewEventDrawer={setNewEventDrawer}
          activeTab={activeTab}
        />
        <MainTabs
          className={"mt-5"}
          tabs={tabs}
          activeTab={activeTab}
          onTabsChange={onTabsChange}
        />

        {displayContent()}
        <MyModal
          className="sendemail-modal"
          open={newEventDrawer}
          onClose={closeModal}
        >
          <NewEvent
            closeModal={closeModal}
            handleClose={closeEventDrawer}
            setCallEventsAgain={setCallEventsAgain}
          />
        </MyModal>
        <MyModal
          className="sendemail-modal"
          open={newTaskDrawer}
          onClose={successFullTask ? closeTaskDrawer : closeModal}
        >
          <NewTask
            closeModal={closeModal}
            handleClose={closeTaskDrawer}
            setCallTasksAgain={setCallTasksAgain}
            successFullTask={successFullTask}
            setSuccessFullTask={setSuccessFullTask}
          />
        </MyModal>

        <RightDrawer
          open={openEventDrawer}
          onClose={() => {
            setOpenEventDrawer(false);
            setSelectedEvent(null);
          }}
        >
          <EventsDrawer
            name={selectedEvent?.name || ""}
            eventData={selectedEvent}
            setOpenEventDrawer={setOpenEventDrawer}
            openMemberEventDrawer={openMemberEventDrawerHandler}
            callEventsTypeAgain={callEventsTypeAgain}
          />
        </RightDrawer>
        {openMemberEventDrawer && (
          <EventDrawer
            open={openMemberEventDrawer}
            onClose={closeMemberEventDrawerHandler}
            account={{
              main_contact: {
                account_id:
                  selectedProfile?.easy_contact_id ??
                  selectedContact?.easy_contact_id,
              },
            }}
            selectedData={{
              easy_contact_id:
                selectedProfile?.easy_contact_id ??
                selectedContact?.easy_contact_id,
              eventId: selectedProfile?.eventId,
            }}
            openNewTaskDrawer={() => setNewTaskDrawer(true)}
            eventOpenData={[]}
            refetchCallback={() => {
              setCallFeedsAgain((prevState) => !prevState);
            }}
          />
        )}

        {openContactDrawer && (
          <SideDrawer
            open={openContactDrawer}
            onClose={closeContactDrawerHandler}
            account={{
              main_contact: {
                account_id: selectedContact?.easy_contact_id,
              },
            }}
            selectedData={{
              easy_contact_id: selectedContact?.easy_contact_id,
            }}
            handleEvent={handleEvent}
          />
        )}

        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
        <AlertDialog
          open={openConfirmation}
          onDecline={closeConfirmationHandler}
          onAccept={() => {
            deleteEventHandler();
          }}
          title="Are you sure?"
          description={"Do you want to delete this event?"}
          disabled={deleteEventLoading}
        />
      </div>
    </>
  );
};

export default Events;
